import './../css/app.pcss';

import { createApp } from 'vue';

// Commons
import header from '/src/ts/commons/header.ts';
import footer from '/src/ts/commons/footer.ts';
import csrf from '/src/ts/commons/csrf.ts';

// Modules
import { inlineLightbox } from '/src/ts/modules/lightbox.ts';

// Stores
import CustomerStore from '/src/vue/stores/customer.ts';

// Components
import CustomerAnnualSpend from '/src/vue/components/CustomerAnnualSpend.ts';
import CustomerContact from '/src/vue/components/CustomerContact.ts';
import CustomerOrderHistory from '/src/vue/components/CustomerOrderHistory.ts';
import CustomerOverview from '/src/vue/components/CustomerOverview.ts';
import CustomerPreviousOrder from '/src/vue/components/CustomerPreviousOrder.ts';

export default function init() {
  csrf();
  // Create our store
  const store = CustomerStore();
  // Header Root Vue Instance
  header(store);
  // Main Root Vue Instance
  const vueInstance = createApp({
    components: {
      CustomerAnnualSpend,
      CustomerContact,
      CustomerOrderHistory,
      CustomerOverview,
      CustomerPreviousOrder,
    },
    setup() {
      /**
       * Get and save the order history to state
       * Required by:
       * CustomerOrderHistory & CustomerPreviousOrder
       */
      store.dispatch('getOrderHistory');
    }
  });
  // Use the store
  vueInstance.use(store);
  // Mount the app
  vueInstance.mount('#customer');
  // Modules
  inlineLightbox();
  // Footer Root Vue Instance
  footer();
}

init();
